import type { AxiosInstance } from 'axios';
import authService from './auth.service';

/**
 * The privacy notice (#289).
 *
 *   GET  /api/v1/privacy-notice           public: the notice in force
 *   (a client accepts it on the one screen after sign-in: legalDocuments.service.ts)
 *
 * Every form that takes personal data echoes the version it showed
 * (`privacy_notice_version`); the server refuses without the one in force.
 */
export interface PrivacyNotice {
  version: number;
  body_en: string;
  /** null until a Spanish text is published; the page then shows the English one. */
  body_es: string | null;
  /** True while the text is a placeholder and not counsel's. */
  is_draft: boolean;
  published_at: string;
}

class PrivacyNoticeService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async current(): Promise<PrivacyNotice> {
    const res = await this.api.get<PrivacyNotice>('/api/v1/privacy-notice');
    return res.data;
  }
}

export default new PrivacyNoticeService();
